import React, { useEffect } from 'react'
import { FeatureImage } from 'js/components/FeatureImage'
import { lpImages } from 'js/pages/LandingPages/imageSources'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'
import { APP_STORE_LINK } from 'js/pages/LandingPages/content'
import AppButtons from 'js/components/AppButtons/AppButtons'

type Props = {
  onClose: () => void
}

const messages = {
  heading: 'How to easily download the app',
  instructions_step_1: 'Open the camera on your phone',
  instructions_step_2:
    'Scan the QR-code and go to the link to your applications store',
  instructions_step_3: 'Download the app',
  app_buttons_heading: 'Download links for mobile',
} as const

const Modal = ({ onClose }: Props) => {
  useEffect(() => {
    pushToDataLayer({
      event: 'download_module_loaded',
      success: '1',
      error_message: undefined,
    })
  }, [])

  return (
    <div className="fixed left-0 top-0 flex h-full w-full items-center justify-center">
      <div
        className="absolute left-0 top-0 z-10 h-full w-full bg-black opacity-56"
        onClick={onClose}
      />
      <div className="relative z-20 rounded-8 bg-BgContent p-24 ">
        <button onClick={onClose} className="absolute right-[24px] top-[24px]">
          <FeatureImage image={lpImages.closeIcon} className="cursor-pointer" />
        </button>
        <div className="grid auto-rows-auto gap-x-[22px] lg:grid-cols-2 lg:grid-rows-1">
          <div className="flex flex-col">
            <h3 className="quincy max-w-[270px] pb-16 text-24 leading-27 lg:max-w-[360px] lg:pb-32 lg:text-32 lg:leading-37">
              {messages.heading}
            </h3>
            <ol className="max-w-[310px] lg:max-w-[360px]">
              <li className="text-14 font-semiregular leading-19 lg:text-17 lg:leading-21">
                {messages.instructions_step_1}
              </li>
              <li className="text-14 font-semiregular leading-19 lg:text-17 lg:leading-21">
                {messages.instructions_step_2}
              </li>
              <li className="text-14 font-semiregular leading-19 lg:text-17 lg:leading-21">
                {messages.instructions_step_3}
              </li>
            </ol>
            <FeatureImage
              image={lpImages.qrCode}
              className="mt-16 h-[200px] w-[200px] lg:hidden"
            />
            <div className="relative bottom-[-12px] lg:mt-auto">
              <h4 className="mb-16 mt-32 text-14 font-demibold uppercase leading-19 tracking-1.12 ">
                {messages.app_buttons_heading}
              </h4>
              <div className="flex gap-x-[16px]">
                <AppButtons
                  appStoreUrl={APP_STORE_LINK}
                  googlePlayUrl={APP_STORE_LINK}
                />
              </div>
            </div>
          </div>
          <div>
            <FeatureImage
              image={lpImages.qrCode}
              className=" mx-auto hidden lg:mt-[48px] lg:block"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
